/*
 * File: 客户一页纸列表
 */
<template>
    <div style="height: 100%;">
        <table-box
            ref="tableBox"
            :height="config.height"
            :selection="config.selection"
            :index="config.index"
            :columns="config.columns"
            :actions="config.actions"
            v-loading="onePaperList.tableLoading"
            :rows="onePaperList.totalData"
            @action-click="actionClick"
        />
        <div class="footer">
            <lots-pagination @size-change="onePaperList.sizeChange" :current-page.sync="onePaperList.pageNo"
                @current-change="onePaperList.pageChange" size="small"
                layout="total, sizes, prev, pager, next, jumper" :total="onePaperList.pageTotal" />
        </div>

        <!-- 下载 -->
        <DownFileDialog ref="downFileDialogRef" :detailData="params" />
    </div>
</template>

<script>
import { Message } from 'element-ui';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import DownFileDialog from '@/modules/mdm/views/customerModules/customerManage/component/customerPaper/component/downFileDialog/Index.vue';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { filePreview } from '@/utils/filePreview.js';

export default {
    components: { tableBox, lotsPagination, DownFileDialog },
    props: {
        config: { // 表格配置项
            type: Object,
            return: () => {}
        },
        api: { // 列表查询接口
            type: Function,
            return: () => {}
        },
        params: { // 查询参数
            type: Object,
            return: () => {}
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        class FilesDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                return { ...condition, ...props.params };
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const onePaperList = new FilesDetailClass({
            Api: {
                listApi: props.api
            }
        });

        const actionClick = (event, row) => {
            switch (event) {
            case 'preview':
                handlePreview(row);
                break;
            case 'download':
                setupContext.refs.downFileDialogRef.show(row);
                break;
            }
            emit('action-click', event, row);
        };
        // 查看
        const handlePreview = (row) => {
            if (!row.docUrl && !row.pdfUrl) {
                return Message.warning('当前无文档可预览');
            }
            filePreview({
                fileUrl: row.docUrl || row.pdfUrl,
                fileName: row.fileName
            });
        };

        return {
            onePaperList,
            actionClick
        };
    }
};
</script>

<style lang="less" scoped>
.footer {
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
